class DreambabyNotificationHandler {
  static activeNotifications = [];
  static baseBottom = 20;
  static spacing = 10;
  static notificationDuration = 5000;

  static showNotification(message, type) {
    const notification = document.createElement('div');
    notification.className = `dreambaby-notification dreambaby-notification--${type}`;
    notification.textContent = message;

    document.body.appendChild(notification);
    this.activeNotifications.push(notification);
    this.reStackNotifications();

    let slideDownTimeoutId;
    const autoDismissTimeoutId = setTimeout(() => {
      notification.classList.add('slide-down-active');
      slideDownTimeoutId = setTimeout(() => {
        this.removeNotification(notification);
      }, 300);
    }, this.notificationDuration);

    notification.addEventListener('click', () => {
      clearTimeout(autoDismissTimeoutId);
      clearTimeout(slideDownTimeoutId);
      notification.classList.add('slide-down-active');
      setTimeout(() => {
        this.removeNotification(notification);
      }, 300);
    });
  }

  static removeNotification(notification) {
    const index = this.activeNotifications.indexOf(notification);
    if (index > -1) {
      this.activeNotifications.splice(index, 1);
    }
    notification.remove();
    this.reStackNotifications();
  }

  static reStackNotifications() {
    let currentBottom = this.baseBottom;
    this.activeNotifications.forEach(notif => {
      notif.style.bottom = `${currentBottom}px`;
      currentBottom += notif.offsetHeight + this.spacing;
    });
  }
}

window.DreambabyNotificationHandler = DreambabyNotificationHandler;
